import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import pnMergetagReplacer from '../../../lib/utils/pnMergeTagReplacer';
import studyConditionMergeTagReplacer from '../../../lib/utils/studyConditionMergeTagReplacer';
import getCallCenterNumber from '../../../store/selectors/getCallCenterNumber';
import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';

type StTextItemProps = {
  inheritLinkColor?: boolean;
};

export const StText = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'inheritLinkColor',
})<StTextItemProps>(({ inheritLinkColor }) => ({
  '& a': {
    color: inheritLinkColor ? 'inherit' : 'none',
  },
}));

const TextWithStudyPnMergeTag = ({ field, cssClassName, inheritLinkColor }: any) => {
  const { sitecoreContext } = useSitecoreContext();
  const callCenterNumber = getCallCenterNumber(sitecoreContext);
  const siteSettings: any = sitecoreContext?.siteSettings;
  const primaryStudyName = siteSettings?.studyName?.value;
  const primaryConditionName = siteSettings?.projectTherapeuticArea?.fields?.description?.value;
  const [content, setContent] = useState(field);

  useEffect(() => {
    if (callCenterNumber?.value || primaryStudyName || primaryConditionName) {
      const newContent = pnMergetagReplacer(field?.value, String(callCenterNumber?.value), false);
      const newContentWithStudyCondition = studyConditionMergeTagReplacer(
        newContent,
        primaryStudyName,
        primaryConditionName
      );
      setContent({ ...content, value: newContentWithStudyCondition });
    }
  }, [callCenterNumber?.value, primaryStudyName, primaryConditionName]);

  return (
    <StText
      field={content}
      className={cssClassName ? cssClassName : ''}
      inheritLinkColor={inheritLinkColor ? inheritLinkColor : false}
    ></StText>
  );
};

export default TextWithStudyPnMergeTag;
